import React from "react";

const PlaylistCreatedModal = ({ playlistUrl, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-semibold mb-4 text-purple-400">
          Playlist Created!
        </h2>
        <p className="mb-4">
          Your playlist has been successfully created. You can access it here:
        </p>
        <a
          href={playlistUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-purple-400 hover:text-purple-300 break-words"
        >
          {playlistUrl}
        </a>
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlaylistCreatedModal;
